module.exports = __webpack_public_path__ + "static/media/Artboard25.7f02067a.png";